module.exports = __webpack_public_path__ + "img/28.fixed_sink.fc344004.svg";